export enum AvailabilityTypeEnum {
    PICKUP = 'PICKUP',
    DROPOFF = 'DROPOFF'
}
